<ng-template #headerTemplate let-column="column" let-sortDir="sortDir" let-sortFn="sortFn">
  <app-ace-table-default-header [column]="column" [sortDir]="sortDir" (sortChange)="sortFn()"/>
</ng-template>

<ng-template #cellTemplate let-value="value" let-column="column">
  <app-ace-table-default-cell [column]="column" [value]="value"/>
</ng-template>

@if (isReadonly()) {
  <app-ace-table [columnMode]="ColumnMode.flex"
                 [rows]="tableRows"
                 [columns]="columns"
                 [footerHeight]="0"
                 [responsivity]="{widthFrom: 'screen', breakpoint: 'sm'}"/>
} @else {
  @if (rows.length) {
    <div class="row">
      <div class="col-md-5">
        <label class="form-label">{{'Label' | messageTranslate}}</label>
      </div>
      <div class="col-md-5">
        <label class="form-label">{{'External Reference' | messageTranslate}}</label>
      </div>
    </div>
  } @else {
    <div>{{'No External References' | messageTranslate}}</div>
  }
  @for (row of rows.controls; track row; let index = $index) {
    <div class="row">
      <div class="col-md-5 form-group">
        <input class="form-control"
               [formControl]="row.controls.label"
               [placeholder]="'Label' | messageTranslate"
               (blur)="onTouched()"/>
        <app-errors [control]="row.controls.label"/>
      </div>
      <div class="col-md-5 form-group">
        <input class="form-control"
               [formControl]="row.controls.externalReference"
               [placeholder]="'External Reference' | messageTranslate"
               (blur)="onTouched()"/>
        <app-errors [control]="row.controls.externalReference"/>
      </div>
      <div class="col-md-2">
        <app-button visual="link"
                    faIcon="trash"
                    [title]="'Remove' | messageTranslate"
                    [disabled]="rows.disabled"
                    (buttonClick)="removeRow(index)"/>
      </div>
    </div>
  }
}
